import React, { useEffect } from 'react';
import styled from 'styled-components';
import SectionHeader from '../components/SectionHeader';
import missionBg from '../assets/images/mission-bg.jpg';

const MissionSection = styled.section`
  background: linear-gradient(rgba(18, 25, 16, 0.9), rgba(18, 25, 16, 0.9)), url(${missionBg});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
`;

const MissionContent = styled.div`
  display: flex;
  justify-content: center;
`;

const MissionCard = styled.div`
  display: flex;
  background-color: rgba(30, 43, 15, 0.8);
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  overflow: hidden;
  max-width: 800px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const MissionNumber = styled.div`
  background-color: var(--primary-color);
  color: var(--secondary-color);
  font-size: 2.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  min-width: 100px;
  
  @media (max-width: 768px) {
    min-width: 100%;
    padding: 10px;
  }
`;

const MissionDetail = styled.div`
  padding: 30px;
  
  h3 {
    color: var(--secondary-color);
    margin-bottom: 15px;
  }
  
  p {
    font-size: 1.1rem;
    line-height: 1.6;
    
    @media (max-width: 576px) {
      font-size: 1rem;
    }
  }
`;

const Mission = () => {
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('mission-card');
      if (!element) return;
      
      const position = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      if (position.top < windowHeight * 0.75) {
        element.classList.add('animate');
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <MissionSection id="missao">
      <div className="container">
        <SectionHeader title="Missão e Visão" highlight="Visão" />
        <MissionContent>
          <MissionCard id="mission-card">
            <MissionNumber>01</MissionNumber>
            <MissionDetail>
              <h3>Nossa Missão</h3>
              <p>
                Nossa missão é aproveitar soluções tecnológicas inovadoras para 
                capacitar empresas e promover um crescimento sustentável, enquanto 
                nossa visão nos guia para sermos líderes em transformação digital.
              </p>
            </MissionDetail>
          </MissionCard>
        </MissionContent>
      </div>
    </MissionSection>
  );
};

export default Mission;
